import { render, staticRenderFns } from "./FamilyMemberPersonalInfo.vue?vue&type=template&id=11ccea5c&scoped=true"
import script from "./FamilyMemberPersonalInfo.vue?vue&type=script&lang=js"
export * from "./FamilyMemberPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./FamilyMemberPersonalInfo.vue?vue&type=style&index=0&id=11ccea5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ccea5c",
  null
  
)

export default component.exports